
import { BaseBus } from './BaseBus';
import { v_InventoryBus } from './v_InventoryBus';
export class CustomerInventoryPMBus extends BaseBus
{
    constructor(data: CustomerInventoryPMBus = null) {
        super(data);

    }
    CID(): any {
        return this.customerInventoryPmId;
    }
    setId(id: any) {
        this.customerInventoryPmId = id;
    }
    initialize(data: CustomerInventoryPMBus) {
        super.initialize(data);
        //this.insertDt = CommonFunctions.getDate(data.insertDt);
        //this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: CustomerInventoryPMBus) {
        super.setFromForm(data);
        //let dateNow = CommonFunctions.getDateNow();

        //if (this.hasId) {
        //    //this.updateDt = dateNow;
        //    this.insertDt = data.insertDt;
        //    this.insertUserId = data.insertUserId;
        //}
        //else {
        //    this.insertDt = dateNow;
        //    this.insertUserId = data.insertUserId;
        //}

    }
    setBeforeSave() {
     //   this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        //if (this.hasId) {
        //    this.updateUserId = userId;
        //}
        //else {
        //    this.insertDt = date;
        //    this.insertUserId = userId;
        //    this.updateUserId = userId;
        //}
    }

    changeInventoryItem(data: v_InventoryBus) {
        this.number = data.number;
        this.fullDescription = data.fullDescription;
        this.inventoryId = data.inventoryId;
        this.fullDescription = data.fullDescription;

        //this.quantity = 1;
        //this.qtyInStock = data..currentCost;
    }

        customerInventoryPmId: string;
    customerPmid: string;
    inventoryId: string;
    note: string;
    number: string;
    fullDescription: string;
    quantity: Number;

}
